import {
  Inject,
  Injectable,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/internal/Observable';
import { filter, map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { unsubscribeFromAll } from '../pure-functions/rx-helper';
import { ContainsSubscriptions } from './interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiHelper } from './apiHelper';

@Injectable()
export class AuthGuard
  implements
    OnInit,
    OnDestroy,
    CanActivate,
    CanActivateChild,
    ContainsSubscriptions
{
  subs: Subscription[] = [];
  private isBrowser: boolean = false;

  constructor(
    private apiHelper: ApiHelper,
    @Inject(PLATFORM_ID) private platformId: any,
    private authService: AuthService,
    private router: Router,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.subs.push(
        this.authService.checkSessionPublic().subscribe(() => {
          console.log('checkSession: inside AuthGuard');
        }),
      );
    }
  }

  ngOnInit() {}

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  canActivate(): Observable<boolean> {
    return this.checkLogin();
  }

  canActivateChild(): Observable<boolean> {
    return this.checkLogin();
  }

  checkLogin(): Observable<boolean> {
    return this.authService.currentUser$.pipe(
      filter((currentUser) => currentUser !== undefined),
      map((currentUser) => {
        if (!currentUser) {
          this.router.navigate(['/login'], {
            queryParams: {
              redirectURL: window.location.pathname,
              SearchParams: window.location.search || '',
            },
          });
          return false;
        }
        return true;
      }),
    );
  }
}
